<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item @click.native="gohome"><a>首页</a></el-breadcrumb-item>
      <el-breadcrumb-item> 线上理赔申请流程</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="font-size: 28px;font-weight: 500;"> 线上理赔申请流程</span>
      </div>

      <table cellpadding=0 cellspacing=0 align=left width="100%">
        <tr>
          <td width=385 height=35></td>
        </tr>
        <tr>
          <td>

            <p class=MsoNormal><span lang=EN-US style='font-size:15.0pt;font-family:楷体'>1.</span><span
                style='font-size:15.0pt;font-family:楷体'>关注公众号：</span><b><span style='font-size:
24.0pt;font-family:楷体'>人保健康生活</span></b></p>

            <p class=MsoNormal><span
                style='font-size:15.0pt;font-family:楷体'>我的→个人中心→请登录→<b>快速注册</b></span></p>

            <p class=MsoNormal><span style='font-size:15.0pt;font-family:楷体'>（注册时填写<b>患者信息</b>）</span></p>

            <p class=MsoNormal style='margin-left:0cm;text-indent:0cm'><span lang=EN-US
                                                                             style='font-size:15.0pt;font-family:楷体'>2.<span
                style='font:7.0pt "Times New Roman"'>
</span></span><b><span style='font-size:15.0pt;font-family:楷体'>操作步骤：</span></b><span
                style='font-size:15.0pt;font-family:楷体'>公众号 人保健康生活</span></p>

            <p class=MsoNormal style='margin-left:0cm;text-indent:0cm'><span lang=EN-US
                                                                             style='font-size:15.0pt;font-family:楷体'>（1）</span><span
                style='font-size:15.0pt;
font-family:楷体'>服务 →理赔服务→团险理赔</span></p>

          </td>
          <td><img width=170 height=167 src="../assets/xslpewm.png"
                   alt=60fbc59735df94084cb13e4a4eb2d59></td>
        </tr>
      </table>

      <p class=MsoNormal><span style='font-size:15.0pt;font-family:楷体'>（<span
          lang=EN-US>2</span>）选择对应的“保单号码”（以<b>出院时间</b>为准，选择对应年度）</span></p>

      <p class=MsoNormal style='line-height:26.0pt'><span style='font-size:15.0pt;
font-family:楷体'>（<span lang=EN-US>3</span>）账单金额（填写合计金额，目前支持<b><span lang=EN-US>3</span>万元</b>以下）→确认</span>
      </p>

      <p class=MsoNormal style='line-height:26.0pt'><span style='font-size:15.0pt;
font-family:楷体'>（<span lang=EN-US>4</span>）银行卡号（点击图案，拍<b>医保卡</b>正面，自动识别）</span></p>

      <p class=MsoNormal style='line-height:26.0pt'><span style='font-size:15.0pt;
font-family:楷体'>（<span lang=EN-US>5</span>）就诊原因，选择“<b>疾病</b>”→下一步→核实无误后提交</span></p>

      <p class=MsoNormal style='line-height:26.0pt'><span style='font-size:15.0pt;
font-family:楷体'>（<span lang=EN-US>6</span>）第一选项拍“身份证正、反面”</span></p>

      <p class=MsoNormal style='line-height:26.0pt'><span style='font-size:15.0pt;
font-family:楷体'>（<span lang=EN-US>7</span>）第二选项拍“医保卡正面”</span></p>

      <p class=MsoNormal style='line-height:26.0pt'><span style='font-size:15.0pt;
font-family:楷体'>（<span lang=EN-US>8</span>）第三选项，住院拍“</span><b><span
          style='font-size:15.0pt;font-family:"微软雅黑","sans-serif"'>住院发票及出院小结或出院记录</span></b>
        <br/>
        <span
            style='font-size:15.0pt;font-family:楷体'>”，门诊大病或慢病拍“</span><b><span
            style='font-size:15.0pt;font-family:"微软雅黑","sans-serif"'>门诊发票和门诊病历</span></b><span
            style='font-size:15.0pt;font-family:楷体'>”<b>（</b>其他资料不用上传<b>）</b></span></p>

      <p class=MsoNormal style='line-height:26.0pt'><span style='font-size:15.0pt;
font-family:楷体'>（<span lang=EN-US>9</span>）第四选项拍“医保卡背面”→勾选“确认出险信息属实”。</span></p>

      <p class=MsoNormal><span style='font-size:15.0pt;font-family:楷体'>成功后，界面显示理赔号码。</span></p>

      <p class=MsoNormal><b><span lang=EN-US style='font-size:15.0pt;font-family:
楷体'>3.</span></b><b><span style='font-size:15.0pt;font-family:楷体'>理赔查询：</span></b><span
          style='font-size:15.0pt;font-family:楷体'>人保健康生活→服务→理赔服务→理赔记录查询</span></p>

      <p class=MsoNormal style='line-height:26.0pt'><b><span style='font-size:22.0pt;
font-family:方正小标宋简体'>注：按上述流程操作，其他内容不用填写。</span></b></p>

      <p class=MsoNormal><span lang=EN-US style='font-size:15.0pt;font-family:楷体'>&nbsp;</span></p>

      <p class=MsoNormal><span lang=EN-US style='font-size:15.0pt;font-family:楷体'>&nbsp;</span></p>

      <p class=MsoNormal><b><span style='font-size:16.0pt;font-family:楷体'>咨询电话：</span></b><span
          lang=EN-US style='font-size:16.0pt;font-family:楷体'>0427--6656222&nbsp; </span></p>

      <p class=MsoNormal style='line-height:26.0pt'><b><span style='font-size:16.0pt;
font-family:楷体'>工作时间</span></b><span style='font-size:16.0pt;font-family:楷体'>（法定节假日休息）<b>：</b>
</span></p>

      <p class=MsoNormal style='line-height:26.0pt'><b><span lang=EN-US
                                                             style='font-size:16.0pt;font-family:楷体'>&nbsp;</span></b><span
          style='font-size:16.0pt;font-family:楷体'>上午<span lang=EN-US> 8</span>：<span
          lang=EN-US>30--11</span>：<span lang=EN-US>30&nbsp;&nbsp; &nbsp;</span>下午<span
          lang=EN-US>13</span>：<span lang=EN-US>00--17</span>：<span lang=EN-US>00</span></span></p>

      <p class=MsoNormal><b><span style='font-size:16.0pt;font-family:楷体'>公司地址：</span></b><span
          style='font-size:16.0pt;font-family:楷体'>盘锦市兴隆台区市府大街<span lang=EN-US>38</span>号（东晟食府<span
          lang=EN-US>2</span>楼）</span></p>

      <p class=MsoNormal><span lang=EN-US style='font-size:18.0pt;font-family:楷体'>&nbsp;</span></p>


      <!--       <el-divider></el-divider>-->

      <!--      <span>2、工残第2项更改为工伤保险费无欠缴证明（需到所在申报区社保补充工伤窗口办理）</span>-->
      <!--          <el-divider></el-divider>-->

      <!--      <span>3、工残第7项更改为账户复印件或银行卡复印件。（银行卡可提供中行、农行、建行、工行、邮政）</span>-->
      <!--          <el-divider></el-divider>-->
      <!--      <span>4、工亡第2项更改为工伤保险费无欠缴证明（需到所在申报区社保补充工伤窗口办理）</span>-->
      <!--              <el-divider></el-divider>-->
      <!--      <span>5、工亡第6项更改为账户复印件或银行卡复印件，（银行卡可提供中行、农行、建行、工行、邮政）</span>-->
      <!--          <el-divider></el-divider>-->
      <!--      <span>6、工残每5、6、8项把原件已核、签名、日期删除</span>-->
      <!--       <el-divider></el-divider>-->

      <!--      <span>7、工亡第4、5项把原件已核、签名、日期删除</span>-->
      <!--          <el-divider></el-divider>-->

      <!--      <span>8、备注第4项更改为：工亡涉及死亡证明、户口注销证明、殡葬证明提供不了原件的，客户需提供原件到我公司办理，待审核后留存复印件即可。</span>-->
      <!--          <el-divider></el-divider>-->
      <!--      <span>9、备注增加第6项，理赔申请书、自然人登记表、授权委托书、权益转让书需到所在区社保申报补充工伤窗口领取。</span>-->
      <!-- <el-divider></el-divider> -->
      <!-- <span>10.出院记录或出院小结（盖红章）</span>
              <el-divider></el-divider>
      <span>11.理赔金打入单位账户的提供非自然人登记表一套（营业执照、法人身份证、经办人身份证）盖公章</span>
          <el-divider></el-divider>
      <span>12.非本人办理的需填写理赔授权委托书</span>
       <el-divider></el-divider>

      <span>13.理赔金打入单位账户或非本人账户的需填写保险赔款权益转让书（如是单位盖公章、本人按手印，如是其他受益人签名按手印）</span>
          <el-divider></el-divider>

      <span>14.自然人登记表</span>
          <el-divider></el-divider>
      <span style="font-weight: 400;font-size: 24px;">工亡</span>
          <el-divider></el-divider>
      <span>1.工伤决定认定书（红章）</span>
          <el-divider></el-divider>
      <span>2.工伤保险无欠缴证明（社保养老红章）</span>
       <el-divider></el-divider>
      <span>3.交通事故认定书 </span>
       <el-divider></el-divider>
      <span>4.被保险人身份证件2份（原件已核、签名、日期）</span>
       <el-divider></el-divider>
      <span>5.经办人证件（原件已核、签名、日期）</span>
       <el-divider></el-divider>
      <span>6.帐户复印件（原件已核、签名、日期）</span>
       <el-divider></el-divider>
      <span>7.被保险人死亡医学证明、户口注销证明、殡葬证明原件</span>
       <el-divider></el-divider>
      <span>8.理赔申请书</span>
       <el-divider></el-divider>
      <span>9.理赔金打入单位账户的提供非自然人登记表一套（营业执照、法人身份证、经办人身份证）盖公章</span>
       <el-divider></el-divider>
      <span>10.非本人办理的需填写理赔授权委托书</span>
       <el-divider></el-divider>
      <span>11.理赔金打入单位账户或非本人账户的需填写保险赔款权益转让书（如是单位盖公章、如是其他受益人签名按手印）</span>
       <el-divider></el-divider>
      <span>12.自然人登记表</span>
       <el-divider></el-divider>
      <span>备注： </span>
       <el-divider></el-divider>
      <span style="display:block;text-indent:2em;">1、身份证件及账号复印件需要原件已核、已核人员签名及日期。</span>
       <el-divider></el-divider>
      <span style="display:block;text-indent:2em;">2、理赔申请书必须填写完整。（日期不写）</span>
       <el-divider></el-divider>
      <span style="display:block;text-indent:2em;">3、工伤认定书、伤残鉴定书、无欠缴证明等材料单位名头必须一致，均为投保时单位名称，如有特殊情况，请单位开具情况说明并盖公章。</span>
       <el-divider></el-divider>
      <span style="display:block;text-indent:2em;">4、工亡涉及死亡证明、户口注销证明、殡葬证明提供不了原件的，客户可把原件拿到公司让我公司看到原件后留下复印件即可，由本公司人员写上原件已核。</span>
       <el-divider></el-divider>
      <span style="display:block;text-indent:2em;">5、理赔金转让给其他受益人的需提供其他全部法定继承人（父母、配偶、子女）的关系证明和身份证复印件或公证书</span>
       <el-divider></el-divider>
       <span style="font-weight: 400;font-size: 24px;">企补所需理赔材料</span>
       <el-divider></el-divider>
       <span>1.被保险人身份证、银行卡原件及复印件正反面</span>
          <el-divider></el-divider>
      <span>2.盘锦市城镇职工基本医疗保险定点医疗机构的住院结算发票原件</span>
       <el-divider></el-divider>
      <span>3.盘锦市城镇职工基本医疗保险定点医疗机构出具的出院记录</span>
       <el-divider></el-divider>
      <span>4.理赔电话2858666</span>
       <el-divider></el-divider>
      <span>5.报销地址辽宁省盘锦市文圣区河东新城路财富中心A座16-37 中国人民健康保险公司</span> -->
    </el-card>
  </div>
</template>
<script>
export default {
  methods: {
    //返回首页
    gohome() {
      window.sessionStorage.setItem('activePath', "/welcome");
      this.$router.push("/welcome");
      this.reload();
    }
  }
}
</script>
<style lang="less" scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 12px 0;
}
</style>
